module.exports = __webpack_public_path__ + "img/image_big_logo.4f35ad9b.png";